import {
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import { FC } from "react";

interface DeletePermissionDialogProps {
  deletedData: { name: string; content: string };
  handleClose: Function;
  handleDelete: Function;
  open: boolean;
}

const DeletePermissionDialog: FC<DeletePermissionDialogProps> = ({
  handleClose,
  open,
  deletedData: { content, name },
  handleDelete,
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => handleClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          padding: "48px",
          borderRadius: "10px",
          textAlign: "center",
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <Typography color="black" fontWeight="bold">
          Delete {content?.[0]?.toUpperCase() + content?.substring(1)}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => handleClose()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete {name}?
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center" }}>
        {/* Cancel Button */}
        

        {/* Delete Button */}
        <Button
          id={`delete-${content.toLowerCase()}`}
          variant="outlined"
          color="warning"
          onClick={() => handleDelete()}
        >
          Delete
        </Button>
        <Button
          id={`cancel-${content.toLowerCase()}`}
          variant="contained"
          color="primary"
          onClick={() => handleClose()}
          sx={{ opacity: 0.8 }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeletePermissionDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  deletedData: PropTypes.any.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default DeletePermissionDialog;
